import { OneColumnLayout } from '@electricjs/arc';
import { useTranslation } from 'react-i18next';

import { PageErrorComponent } from '@/components/PageErrorComponent';

const PageNotFound = () => {
  const { t } = useTranslation('pages');

  return (
    <OneColumnLayout>
      <PageErrorComponent
        errorType={t('pageNotFound.errorType')}
        title={t('pageNotFound.title')}
        message={t('pageNotFound.message')}
      />
    </OneColumnLayout>
  );
};

export default PageNotFound;
